// Branchement React de `entetes-collants.ts` — monté UNE fois, dans la
// coquille (`App.tsx`) : vaut pour tous les tableaux de tous les modules.

import { useEffect } from 'react';
import { VAR_HAUTEUR, marquerTableaux } from './entetes-collants';

/** Regroupe les rafales de mutations (chargements, listes virtualisées) : une passe au plus toutes les 150 ms. */
const DELAI_MS = 150;

/** `actif` : la coquille est affichée (session établie) — `<main>` n'existe pas avant. */
export function useEntetesCollants(actif: boolean): void {
  useEffect(() => {
    if (!actif) return;
    const racine = document.querySelector('main');
    const chrome = document.querySelector<HTMLElement>('[data-app-shell-chrome]');
    if (!racine) return;

    // Hauteur RÉELLE du chrome (TopBar : 2 lignes, onglets), suivie à chaque redimensionnement.
    const mesurer = (): void => {
      const h = chrome ? Math.round(chrome.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty(VAR_HAUTEUR, `${h}px`);
    };

    let minuteur: ReturnType<typeof setTimeout> | null = null;
    const passe = (): void => {
      minuteur = null;
      marquerTableaux(racine, window.innerWidth);
    };
    const planifier = (): void => {
      if (minuteur === null) minuteur = setTimeout(passe, DELAI_MS);
    };

    mesurer();
    passe();
    const surRedim = (): void => {
      mesurer();
      planifier();
    };
    const obsChrome = typeof ResizeObserver === 'undefined' || !chrome ? null : new ResizeObserver(mesurer);
    obsChrome?.observe(chrome!);
    // Seuls les ajouts/retraits de nœuds comptent (nos propres attributs ne relancent rien).
    const obsDom = new MutationObserver(planifier);
    obsDom.observe(racine, { childList: true, subtree: true });
    window.addEventListener('resize', surRedim);
    return () => {
      if (minuteur !== null) clearTimeout(minuteur);
      obsChrome?.disconnect();
      obsDom.disconnect();
      window.removeEventListener('resize', surRedim);
    };
  }, [actif]);
}
